import { defineMessages } from '@redbubble/next/intl';

export const cartMessages = defineMessages({
  orderSummaryText: {
    defaultMessage: 'Order Summary',
  },
  calculateTaxAtCheckout: {
    defaultMessage: 'Tax will be calculated at checkout',
  },
});
